import { BiVisualizationBody } from '@euler/app/components/message/widgets/bi-visualization/BiVisualizationBody';
import { BiViewMode } from '@euler/app/components/message/widgets/bi-visualization/functions/biViewMode';
import { biVizIcon } from '@euler/app/components/message/widgets/bi-visualization/functions/biVizIcon';
import { useBiViewMode } from '@euler/app/components/message/widgets/bi-visualization/functions/useBiViewMode';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiDraftView } from '@euler/model/bi/draft';
import { BiPalette } from '@euler/model/bi/viz';
import { memo } from 'react';
import { ScrollView } from 'react-native';
import { BiCardKind } from '../../functions/biCardKind';
import { biRowsHeight, kBiCardKindRows } from '../../functions/biGridLayout';
import { CardFrame } from '../card/CardFrame';

/** A card the change set adds, drawn from its draft's snapshot. */
export const GhostDraftCard = memo(
  ({
    draft,
    title,
    height,
    palette,
    onFitHeight,
  }: {
    draft: BiDraftView;
    title: string;
    height?: number;
    palette: BiPalette;
    /** Without a height: the height its content needs (`CardFrame`). */
    onFitHeight?: (px: number) => void;
  }) => {
    const compact =
      height !== undefined &&
      height < biRowsHeight(kBiCardKindRows[BiCardKind.Kpi]);
    const { rpx } = useResponsiveContext();
    const { view, toggle } = useBiViewMode(draft.viz, draft.result.current);
    const body = (
      <BiVisualizationBody
        viz={draft.viz}
        result={draft.result}
        compact={compact}
        view={view}
        palette={palette}
      />
    );
    return (
      <CardFrame
        icon={biVizIcon(draft.viz.type)}
        title={title}
        subtitle="预览 · 应用后按看板的筛选重新计算"
        trailing={toggle}
        height={height}
        compact={compact}
        onFitHeight={onFitHeight}
      >
        {view === BiViewMode.Table ? (
          <ScrollView
            style={{ flex: 1 }}
            contentContainerStyle={{ gap: rpx(8) }}
          >
            {body}
          </ScrollView>
        ) : (
          body
        )}
      </CardFrame>
    );
  },
);
